import  { CARGAR_CHEQUES } from './actionTypes';
import global_axios from '../../funciones_globales/interaccionapi';
import { VISUALIZAR_ALERTA, VISUALIZAR_LOADING } from '../generales/actionTypes';

export const cargar_ChequesporCliente = (cliente, estadoCheque) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/clientes/' + cliente + '/cheques?estado=' + estadoCheque			
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let cheques = response.data;			
			dispatch({
				type: CARGAR_CHEQUES,
				data: cheques
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar cheques del cliente', mensaje: msgError}
			});
		});
	}
}

export const cargar_ChequesporClienteEntrega = (cliente) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/clientes/' + cliente + '/chequesentregado' 			
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let cheques = response.data;			
			dispatch({
				type: CARGAR_CHEQUES,
				data: cheques
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar cheques del cliente', mensaje: msgError}
			});
		});
	}
}